import { render, staticRenderFns } from "./budget.vue?vue&type=template&id=9229e73c&"
import script from "./budget.vue?vue&type=script&lang=js&"
export * from "./budget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./budget.vue?vue&type=custom&index=0&blockType=budget&scoped=true"
if (typeof block0 === 'function') block0(component)

export default component.exports